import { fb, validators } from '../../../lib/form';

export function GetLoginModel(data){
  const model = fb.group({
    userName: [data.userName || '', [validators.Required()], { label: 'Email', type: 'text' }],
    password: [data.password || '', [validators.Required()], { label: 'Password', type: 'password' }],
  }); 
  return model;
}